import React from "react";
import PhoneHero from "./PhoneHero";
import PhoneTrustBar from "./PhoneTrustBar";
import PhoneBenefits from "./PhoneBenefits";
import PhoneHowItWorks from "./PhoneHowItWorks";
import PhoneLoginSample from "./PhoneLoginSample";
import PhoneCompliance from "./PhoneCompliance";
import PhoneCta from "./PhoneCta";
import Footer from "../../components/Footer/Footer";
import { PageWrapper } from "./PhoneLanding.elements";
import SEOHelmet from "../../components/SEOHelmet/SEOHelmet";

const phoneStructuredData = {
  "@context": "https://schema.org",
  "@type": "Service",
  "name": "Phone Number Verification Nigeria",
  "serviceType": "Phone Identity Verification",
  "provider": {
    "@type": "Organization",
    "name": "e-citizen",
    "url": "https://e-citizen.ng"
  },
  "description": "Verify the owner of any Nigerian phone number. Get full name, address details, and date of birth linked to any MTN, Airtel, Glo, or 9mobile number.",
  "areaServed": {
    "@type": "Country",
    "name": "Nigeria"
  },
  "url": "https://e-citizen.ng/phone-number-verification"
};

const PhoneVerificationPage = () => {
  return (
    <PageWrapper>
      <SEOHelmet
        title="Phone Number Verification Nigeria – Find Owner of Any Number | e-citizen"
        description="Verify the owner of any Nigerian phone number (MTN, Airtel, Glo, 9mobile). Get full name, address, and date of birth instantly. Secure phone number lookup powered by official telco data."
        canonical="/phone-number-verification"
        keywords="phone number verification Nigeria, phone number lookup Nigeria, verify phone owner Nigeria, MTN number check, Airtel number owner, ecitizen phone"
        structuredData={phoneStructuredData}
      />
      <PhoneHero />
      <PhoneTrustBar />
      <PhoneBenefits />
      <PhoneHowItWorks />
      <PhoneLoginSample />
      <PhoneCompliance />
      <PhoneCta />
      <Footer />
    </PageWrapper>
  );
};

export default PhoneVerificationPage;

